// extracted by mini-css-extract-plugin
export default {"container":"vehicle_container__UhN9S"};